import { default as domainArpRecords } from './records/services'

export default {
    domainArpRecords,
}
